import { mapActions } from 'vuex'
import { ErrorHelper } from '../../helpers/ErrorHelper'
import { MarketingSettingCacheMixin } from './MarketingSettingCacheMixin'

export const MarketingSettingUpdateMixin = {
  mixins: [MarketingSettingCacheMixin],
  data () {
    return {
      marketing: null,
      marketingSettingValidation: ''
    }
  },
  computed: {
    marketingSettingUpdateModel () {
      return this.marketingSettingCache
        ? Object.assign({}, this.marketingSettingCache, {
          marketing: this.marketing
        })
        : {}
    },
    inviteId () {
      console.log('!!!OVERRIDE COMPUTED - inviteId!!!')
    }
  },
  watch: {
    marketing () {
      this.validateMarketingSetting()
    }
  },
  methods: {
    ...mapActions('RegistrationMarketingSetting', [
      'updateMarketingSetting'
    ]),
    tryUpdateMarketingSetting () {
      const self = this
      self.validateMarketingSetting()
      if (!!self.marketingSettingValidation || self.loadingMarketingSetting) {
        return
      }
      self.error = ''
      return self.updateMarketingSetting({ inviteId: self.inviteId, payload: self.marketingSettingUpdateModel })
        .then(response => { self.afterUpdateMarketingSetting(response.data) })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterUpdateMarketingSetting()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
    },
    afterUpdateMarketingSetting () {
      // override if necessary
    },
    validateMarketingSetting () {
      if (this.marketing === null) {
        this.marketingSettingValidation = 'Please select an option'
      } else {
        this.marketingSettingValidation = ''
      }
    }
  }
}
